// extracted by mini-css-extract-plugin
module.exports = {"description":"MigrationModalBody_description__1N8de","spinner":"MigrationModalBody_spinner__2CFYx","warning":"MigrationModalBody_warning__knfNl"};